// extracted by mini-css-extract-plugin
export default {"main__container":"Main_main__container__5c+Dy","main__leftPanel":"Main_main__leftPanel__7PSZb","main__rightPanel":"Main_main__rightPanel__-7ht6"};